// extracted by mini-css-extract-plugin
module.exports = {"headerSocial":"CqS9Zj","transparentBackground":"Mo3lyp","item":"aI0YZC","mailIcon":"UjGv4U"};